(function () {
    'use strict';

    angular
        .module('app')
        .factory('autoNameService', autoNameService);

    //2018 SP1 Refactor: 20180828 - GT
    //inject extractionservice to call updateextractiondata, clearextracteddata and getplugindefinitions
    autoNameService.$inject = ['$rootScope', '$mdDialog', '$localStorage', 'optionsService', '$state', '$q', 'loginService',
        'gridDataService', '$window', '$http', '$filter', 'zcs', 'selectionCommandService', 'commandService',
        'extractionservice', 'dataCardService'];

    function autoNameService($rootScope, $mdDialog, $localStorage, optionsService, $state, $q, loginService,
        gridDataService, $window, $http, $filter, zcs, selectionCommandService, commandService,
        extractionservice, dataCardService) {

        var service = {
            IsAutoNameEnabled: IsAutoNameEnabled,
            GetAutoNameFormats: GetAutoNameFormats,
            GetAutoNameFormat: GetAutoNameFormat,
            GetNextAutoNameSamples: GetNextAutoNameSamples,
            GenerateAutoName: GenerateAutoName,
            AutoNameUpdateRecord: AutoNameUpdateRecord,
            UpdateDocument: UpdateDocument,
            ValidateInputLength: ValidateInputLength
        };
        return service;

        function IsAutoNameEnabled() {
            var deferred = $q.defer();
            var request = $http.get('../Synergis.WebApi/api/AutoName/Enabled');
            request.then(function (response) {
                deferred.resolve(response.data);
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function GetAutoNameFormats() {
            var deferred = $q.defer();
            var request = $http.get('../Synergis.WebApi/api/AutoName/Formats');
            request.then(function (response) {
                deferred.resolve(response.data);
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function GetAutoNameFormat(formatId) {
            var deferred = $q.defer();
            var request = $http.get('../Synergis.WebApi/api/AutoName/Format/' + formatId);
            request.then(function (response) {
                deferred.resolve(response.data);
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function GetNextAutoNameSamples(count, autoNameFormatModel) {
            var deferred = $q.defer();
            var request = $http({
                url: '../Synergis.WebApi/api/AutoName/NextAutoNameSamples/' + count,
                method: 'PUT',
                data: JSON.stringify(autoNameFormatModel),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            request.then(function (response) {
                var data = response.data;
                // Handle case where this format does not have an auto-sequence. This means the return list will only have a single entry.
                if (autoNameFormatModel.allowFormatWithoutAutoGeneratedSegment && data.Samples.length !== count) {
                    for (var index = data.Samples.length; index <= count; index++) {
                        data.Samples.push(data.Samples[0])
                    }
                }
                deferred.resolve(response);
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function GenerateAutoName(autoNameFormatModel) {
            var deferred = $q.defer();
            var request = $http({
                url: '../Synergis.WebApi/api/AutoName/GenerateAutoName',
                method: 'PUT',
                data: JSON.stringify(autoNameFormatModel),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            request.then(function (response) {
                deferred.resolve(response);
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function AutoNameUpdateRecord(selectionItem, autoNameFormatModel) {
            var deferred = $q.defer();
            var request = $http({
                url: '../Synergis.WebApi/api/AutoName/UpdateRecord/' + selectionItem.fileId,
                method: 'PUT',
                data: JSON.stringify(autoNameFormatModel),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            request.then(function (response) {
                deferred.resolve(response);
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        ////////////////////////////////////////
        // Update Document - Autoname
        // 
        // Called to push Format/Segment values to the document's extracted fields.
        ////////////////////////////////////////
        function UpdateDocument(selectionItem, autoNameFormatModel, filename) {
            var deferred = $q.defer();
            var fieldValues = {};
            var libraryId = (selectionItem && selectionItem.detailedInfo && selectionItem.detailedInfo.libId);

            // Check if there is something to update from the format.
            var fieldDef = autoNameFormatModel.associatedFieldDefinition;
            if (fieldDef)
                fieldValues[fieldDef.id] = autoNameFormatModel.generatedName;

            // Walk segments.
            angular.forEach(autoNameFormatModel.segments, function (segment) {
                // If there is something to update, do it now.
                fieldDef = segment.associatedFieldDefinition;
                if (fieldDef)
                    fieldValues[fieldDef.id] = segment.userData;
            });

            dataCardService.UpdateDocument(fieldValues,
                filename,
                selectionItem.tableNumber,
                selectionItem.fileId,
                selectionItem.majRev,
                selectionItem.minRev,
                libraryId
            ).then(function () {
                    deferred.resolve();
                }, function (response) {
                    deferred.reject(response);
                });
            return deferred.promise;
        }

        function RetrieveDocumentModel(tableNumber, fileId, majRev, minRev) {
            var deferred = $q.defer();
            var request = $http({
                url: '../Synergis.WebApi/api/Document/GetDocumentModel/'.concat(tableNumber, '/', fileId, '/', majRev, '/', minRev),
                method: 'GET',
                data: JSON.stringify(''),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            request.then(function (response) {
                deferred.resolve(response);
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function ValidateInputLength(segment, data) {
            var validateInput = { segment: segment, data: data };
            var deferred = $q.defer();
            var request = $http({
                url: '../Synergis.WebApi/api/AutoName/ValidateInputLength',
                method: 'PUT',
                data: JSON.stringify(validateInput),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            request.then(function (response) {
                deferred.resolve(response);
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }
    }
})();